export default __webpack_public_path__ + "static/media/paprika_jancsi_etterem_06.6d39ab0f.JPG";